module.exports = __webpack_public_path__ + "img/online-heading.73767453.svg";